import { makeRequest } from '../../../lib/api';
import {
  BaseInformerInterface,
  UpdateInformerInterface,
} from '../api/informerApi';

const INFORMER_PATH = '/v1/nomenclature/informer';

const informerController = {
  getInformers: (showDeleted:boolean): Promise<any> => {
    const showDeletedString = showDeleted ? '?showDeleted=true' : '';
    return makeRequest('get', `${ INFORMER_PATH }${ showDeletedString }`);
  },

  createInformer: (request: BaseInformerInterface): Promise<any> => {
    return makeRequest('post', INFORMER_PATH, request);
  },

  updateInformer: (request: UpdateInformerInterface): Promise<any> => {
    return makeRequest('put', `${ INFORMER_PATH }/${ request.id }`, request);
  },

  deleteInformer: (id: string): Promise<any> => {
    return makeRequest('delete', `${ INFORMER_PATH }/${ id }`);
  },

  restoreInformer: (id: string): Promise<any> => {
    return makeRequest('post', `${ INFORMER_PATH }/${ id }/restore `);
  },
};

export { informerController };
